module.exports = __webpack_public_path__ + "static/img/expire.7431907f.png";